var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSingleChoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 4.16129C11.6742 4.16129 13.8387 6.32543 13.8387 9C13.8387 11.6742 11.6746 13.8387 9 13.8387C6.32584 13.8387 4.16129 11.6746 4.16129 9C4.16129 6.32584 6.32543 4.16129 9 4.16129ZM9 3C5.68628 3 3 5.68628 3 9C3 12.3137 5.68628 15 9 15C12.3137 15 15 12.3137 15 9C15 5.68628 12.3137 3 9 3ZM9 7.06452C7.93106 7.06452 7.06452 7.93106 7.06452 9C7.06452 10.0689 7.93106 10.9355 9 10.9355C10.0689 10.9355 10.9355 10.0689 10.9355 9C10.9355 7.93106 10.0689 7.06452 9 7.06452Z",
  fill: "currentColor"
})));
export default SvgSingleChoice;